import { FC } from 'react';
import { ActiveFileDataSource, PendingFileDataSource } from './file';
import { OverviewTabProps } from './types/types';

export const FileOverview: FC<OverviewTabProps> = ({ dataSource, isActive }) => {
  return <>{isActive ? <ActiveFileDataSource dataSource={dataSource} /> : <PendingFileDataSource dataSource={dataSource} />}</>;
};
